module.exports = {"name":"yMultiplier","value":35}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/signals/inputs/y-multiplier.json
// module id = WESL
// module chunks = 0